import * as yup from 'yup';
import { INN_FIELD_ERROR } from './constants';

const innSchema = yup.string().matches(/^\d{12}$/, INN_FIELD_ERROR);

export default innSchema;
